import lazyLoad from 'app/shared-components/util/lazyLoad';

const PublicTaskApp = lazyLoad(() => import('./PublicTaskApp'));

const PublicTaskAppConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: null, // No authentication required
  routes: [
    {
      path: 'task/:code',
      element: <PublicTaskApp />,
    },
    {
      path: 'task',
      element: <PublicTaskApp />,
    },
  ],
};

export default PublicTaskAppConfig;